import { RECAPTCHA_SITE_KEY } from "../../../env";

export const executeWithRecaptcha = (callback: any, actionKey: string) => {
  const win = window as any;

  if (RECAPTCHA_SITE_KEY && win.grecaptcha) {
    win.grecaptcha.ready((_: any) => {
      win.grecaptcha
        .execute(RECAPTCHA_SITE_KEY, { action: actionKey })
        .then((token: string) => {
          callback(token);
        });
    });
  } else {
    callback();
  }
};
